import { Ref, useEffect, useRef, useState } from 'react'

import { Nullable } from '@/shared/lib/utils/utilsTypes'

/**
 * Swiper hook for control buttons and element ref
 * @example
 *   const [nextEl, nextElRef] = useSwiperRef<HTMLButtonElement>();
 *   const [prevEl, prevElRef] = useSwiperRef<HTMLButtonElement>();
 *        <Swiper
 *             navigation={{
 *               prevEl,
 *               nextEl,
 *             }}
 *           >
 *         </Swiper>
 *      <S.ActionList__NavigationButton prev ref={nextElRef}>
 *        <Icon/>
 *      </S.ActionList__NavigationButton>
 *
 */

export const useSwiperRef = <T extends HTMLElement>(): [T | Nullable<HTMLElement>, Ref<T>] => {
	const [wrapper, setWrapper] = useState<T | Nullable<HTMLElement>>(null)
	const ref = useRef<T>(null)

	useEffect(() => {
		if (ref.current) {
			setWrapper(ref.current)
		}
	}, [])

	return [wrapper, ref]
}
